import type { TowerShipment } from "../../types/controlTower";

// Las fechas de estado llegan normalizadas como YYYY-MM-DD HH:mm desde el
// backend, así que el orden lexicográfico coincide con el orden temporal.
export function findLatestDeliveredShipment(shipments: TowerShipment[]): TowerShipment | null {
  return shipments.reduce<TowerShipment | null>((latest, shipment) => {
    if (shipment.status !== "delivered" || !shipment.stateDate) return latest;
    return !latest || !latest.stateDate || shipment.stateDate > latest.stateDate ? shipment : latest;
  }, null);
}
